const firebaseConfig = {
    apiKey: "AIzaSyB_VqseC6fEY2ovdP09hqKBKv2bkBdoOcU",
    authDomain: "quick-ride-be146.firebaseapp.com",
    projectId: "quick-ride-be146",
    storageBucket: "quick-ride-be146.appspot.com",
    messagingSenderId: "543559110515",
    appId: "1:543559110515:web:749b25f0cd2b662f483f06"
  };

  export default firebaseConfig;
  